export function formatTitle(title: string) {
  const formattedTitle = title
    .replace("PNEU", "")
    // .replace("MICHELIN", "")
    .replace("BFGOODRICH", "")
    .replace("AGILIS 51", "")
    .replace("AGILIS R", "")
    .replace("AGILIS 3", "")
    .replace("AGILIS+", "")
    .replace("AGILIS", "")
    .replace("ENERGY XM2+", "")
    .replace("LATITUDE CROSS", "")
    .replace("LATITUDE SPORT 3 ACOUSTIC", "")
    .replace("LATITUDE SPORT 3 ZP RUN FLAT", "")
    .replace("LATITUDE SPORT 3", "")
    .replace("LATITUDE SPORT", "")
    .replace("LATITUDE TOUR HP", "")
    .replace("LTX FORCE", "")
    .replace("MUD TERRAIN TA KM3", "")
    .replace("PILOT PRIMACY", "")
    .replace("PILOT SPORT 2 ZP RUN FLAT", "")
    .replace("PILOT SPORT 2", "")
    .replace("PILOT SPORT 3 ZP RUN FLAT", "")
    .replace("PILOT SPORT 3", "")
    .replace("PILOT SPORT 5", "")
    .replace("PILOT PRIMACY", "")
    .replace("PILOT SPORT 2 ZP RUN FLAT", "")
    .replace("PILOT SPORT 2", "")
    .replace("PILOT SPORT 3 ZP RUN FLAT", "")
    .replace("PILOT SPORT 3", "")
    .replace("PILOT SPORT 4 ZP RUN FLAT", "")
    .replace("PILOT SPORT 4 ACOUSTIC", "")
    .replace("PILOT SPORT 4 SUV", "")
    .replace("PILOT SPORT 4 S", "")
    .replace("PILOT SPORT 4", "")
    .replace("PILOT SPORT CUP 2 R", "")
    .replace("PILOT SPORT CUP 2", "")
    .replace("PILOT SUPER SPORT", "")
    .replace("PRIMACY 3 ZP RUN FLAT", "")
    .replace("PRIMACY 3", "")
    .replace("PRIMACY 4+", "")
    .replace("PRIMACY 4", "")
    .replace("PRIMACY HP ZP RUN FLAT", "")
    .replace("PRIMACY LC", "")
    .replace("PRIMACY SUV", "")
    .replace("X LT AS", "")
    .replace("ALL TERRAIN TA KO2", "")
    .replace("MUD TERRAIN TA KM3", "")
    .replace("ALL TERRAIN KO2", "");
  return formattedTitle?.toUpperCase();
}

export function formatFilterTitle(title: string) {
  const formattedTitle = title
    .replace("LoadIndex", "ÍNDICE DE CARGA")
    .replace("SpeedIndex", "ÍNDICE DE VELOCIDADE")
    .replace("WheelCode", "CÓDIGO DA RODA")
    .replace("Rim", "ARO")
    .replace("Series", "ALTURA")
    .replace("Width", "LARGURA");

  return formattedTitle;
}

export function formatOptions(option: string) {
  const formattedOption = option
    .replace("PNEU", "")
    .replace("pneu", "")
    .replace("PILOT SPORT 4 S MICHELIN", "")
    .replace("PILOT SPORT 4 S MICHELIN", "");

  return formattedOption;
}

type ProductName = {
  nameProduct: string;
  model: string;
};

export function formatProductName(name: string): ProductName {
  const nameProduct = name?.replace(
    /(AGILIS\W51|AGILIS\WR|AGILIS\W3|AGILIS\+|AGILIS|ENERGY\WXM2\+|LATITUDE\WCROSS|LATITUDE\WSPORT\W3\WZP\WRUN\WFLAT|LATITUDE\WSPORT\W3\WACOUSTIC|LATITUDE\WSPORT\W3|LATITUDE\WSPORT|LATITUDE\WTOUR\WHP|LTX\WFORCE|LTX\WAT2|LTX\WMS2|G\WGRIP|MUD\WTERRAIN\WTA\WKM3|MUD\WTERRAIN|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W5|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W3|PILOT\WSPORT\W4\WZP\WRUN\WFLAT|PILOT\WSPORT\W4\WACOUSTIC|PILOT\WSPORT\W4\WSUV|PILOT\WSPORT\W4\WS|PILOT\WSPORT\W4|PILOT\WSPORT\WCUP\W2\WR|PILOT\WSPORT\WCUP\W2|PILOT\WSUPER\WSPORT|PRIMACY\W3\WZP\WRUN\WFLAT|PRIMACY\W3|PRIMACY\W4\+|PRIMACY\W4|PRIMACY\WHP\WZP\WRUN\WFLAT|PRIMACY\WHP|PRIMACY\WLC|PRIMACY\WSUV|X\WLT\WAS|ALL\WTERRAIN\WTA\WKO2|MUD\WTERRAIN\WTA\WKM3|ALL\WTERRAIN\WKO2|ALL\WTERRAIN\WKO|ALL\WTERRAIN|RADIAL\WTA)(\W(MICHELIN|BFGOODRICH))?/gm,
    ""
  );
  const model = name
    ?.match(
      /(AGILIS\W51|AGILIS\WR|AGILIS\W3|AGILIS\+|AGILIS|ENERGY\WXM2\+|LATITUDE\WCROSS|LATITUDE\WSPORT\W3\WZP\WRUN\WFLAT|LATITUDE\WSPORT\W3\WACOUSTIC|LATITUDE\WSPORT\W3|LATITUDE\WSPORT|LATITUDE\WTOUR\WHP|LTX\WFORCE|LTX\WAT2|LTX\WMS2|G\WGRIP|MUD\WTERRAIN\WTA\WKM3|MUD\WTERRAIN|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W5|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W3|PILOT\WSPORT\W4\WZP\WRUN\WFLAT|PILOT\WSPORT\W4\WACOUSTIC|PILOT\WSPORT\W4\WSUV|PILOT\WSPORT\W4\WS|PILOT\WSPORT\W4|PILOT\WSPORT\WCUP\W2\WR|PILOT\WSPORT\WCUP\W2|PILOT\WSUPER\WSPORT|PRIMACY\W3\WZP\WRUN\WFLAT|PRIMACY\W3|PRIMACY\W4\+|PRIMACY\W4|PRIMACY\WHP\WZP\WRUN\WFLAT|PRIMACY\WHP|PRIMACY\WLC|PRIMACY\WSUV|X\WLT\WAS|ALL\WTERRAIN\WTA\WKO2|MUD\WTERRAIN\WTA\WKM3|ALL\WTERRAIN\WKO2|ALL\WTERRAIN\WKO|ALL\WTERRAIN|RADIAL\WTA)/gm
    )
    ?.at(0);

  return { nameProduct, model };
}

export function formatLandingPageName(name: string) {
  const nameProduct = name
    // ?.replace(model, "")
    .replace("LingLong", "")
    .replace("PNEU", "");

  // .replace("MICHELIN", "")
  // .replace("BFGOODRICH", "")
  // .replace("PNEU", "");

  return nameProduct;
}

export function useProductName(
  name: string,
  removeType: boolean = false
): [Name: string, Model: string] {
  const Name = name.replace(
    /(AGILIS\W51|AGILIS\WR|AGILIS\W3|AGILIS\+|AGILIS|ENERGY\WXM2\+|LATITUDE\WCROSS|LATITUDE\WSPORT\W3\WZP\WRUN\WFLAT|LATITUDE\WSPORT\W3\WACOUSTIC|LATITUDE\WSPORT\W3|LATITUDE\WSPORT|LATITUDE\WTOUR\WHP|LTX\WFORCE|LTX\WAT2|LTX\WMS2|G\WGRIP|MUD\WTERRAIN\WTA\WKM3|MUD\WTERRAIN|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W5|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W3|PILOT\WSPORT\W4\WZP\WRUN\WFLAT|PILOT\WSPORT\W4\WACOUSTIC|PILOT\WSPORT\W4\WSUV|PILOT\WSPORT\W4\WS|PILOT\WSPORT\W4|PILOT\WSPORT\WCUP\W2\WR|PILOT\WSPORT\WCUP\W2|PILOT\WSUPER\WSPORT|PRIMACY\W3\WZP\WRUN\WFLAT|PRIMACY\W3|PRIMACY\W4\+|PRIMACY\W4|PRIMACY\WHP\WZP\WRUN\WFLAT|PRIMACY\WHP|PRIMACY\WLC|PRIMACY\WSUV|X\WLT\WAS|ALL\WTERRAIN\WTA\WKO2|MUD\WTERRAIN\WTA\WKM3|ALL\WTERRAIN\WKO2|ALL\WTERRAIN\WKO|ALL\WTERRAIN|RADIAL\WTA)(\W(MICHELIN|BFGOODRICH))?/gm,
    ""
  );

  const Model = name.match(
    /(AGILIS\W51|AGILIS\WR|AGILIS\W3|AGILIS\+|AGILIS|ENERGY\WXM2\+|LATITUDE\WCROSS|LATITUDE\WSPORT\W3\WZP\WRUN\WFLAT|LATITUDE\WSPORT\W3\WACOUSTIC|LATITUDE\WSPORT\W3|LATITUDE\WSPORT|LATITUDE\WTOUR\WHP|LTX\WFORCE|LTX\WAT2|LTX\WMS2|G\WGRIP|MUD\WTERRAIN\WTA\WKM3|MUD\WTERRAIN|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W5|PILOT\WPRIMACY|PILOT\WSPORT\W2\WZP\WRUN\WFLAT|PILOT\WSPORT\W2|PILOT\WSPORT\W3\WZP\WRUN\WFLAT|PILOT\WSPORT\W3|PILOT\WSPORT\W4\WZP\WRUN\WFLAT|PILOT\WSPORT\W4\WACOUSTIC|PILOT\WSPORT\W4\WSUV|PILOT\WSPORT\W4\WS|PILOT\WSPORT\W4|PILOT\WSPORT\WCUP\W2\WR|PILOT\WSPORT\WCUP\W2|PILOT\WSUPER\WSPORT|PRIMACY\W3\WZP\WRUN\WFLAT|PRIMACY\W3|PRIMACY\W4\+|PRIMACY\W4|PRIMACY\WHP\WZP\WRUN\WFLAT|PRIMACY\WHP|PRIMACY\WLC|PRIMACY\WSUV|X\WLT\WAS|ALL\WTERRAIN\WTA\WKO2|MUD\WTERRAIN\WTA\WKM3|ALL\WTERRAIN\WKO2|ALL\WTERRAIN\WKO|ALL\WTERRAIN|RADIAL\WTA)/gm
  )?.[0];
  return [removeType ? Name?.replace("PNEU", "") : Name, Model];
}

type runflatProps = {
  modelName: string;
  hasRunflat: boolean;
};

export function formatTypeRunFlat(name: string): runflatProps {
  const modelName = name?.replace("RUN FLAT", "");

  const hasRunflat = name?.match(/RUN FLAT/g) ? true : false;

  return { modelName, hasRunflat };
}

export function formatModelTitle(title: string) {
  return title.replace("-", " ").replace("-", " ").replace("-", " ");
}

export function useRunFlat(model: string): [ModelWithoutRF: string, HasRunFlat: boolean] {
  const modelName = model?.replace("RUN FLAT", "");
  const hasRunflat = model?.match(/RUN FLAT/g) ? true : false;
  return [modelName, hasRunflat];
}
